import * as yup from "yup";

const PerfilValidacion = yup.object().shape({
    nombre: yup.string().required()
});

export default PerfilValidacion;